module.exports = __webpack_public_path__ + "static/media/stripe-create-account_9.6228f719.png";